import Button from "../../mantine/button/Button";
import styles from "./GoToPageMenu.module.scss";

interface GoToPageMenuProps {
  totalPages: number;
  currentPage: number;
  onSubmit: (page: number) => void;
}

export const GoToPageMenu: React.FC<GoToPageMenuProps> = ({
  totalPages,
  currentPage,
  onSubmit,
}) => {
  const handlePageClick = (page: number) => {
    onSubmit(page);
  };

  return (
    <div className={styles.buttonList}>
      <div className={styles.buttonListLabel}>Go to page</div>
      <div className={styles.buttonListContainer}>
        {Array.from({ length: totalPages }, (_, index) => {
          const pageNumber = index + 1;

          return (
            <Button
              key={pageNumber}
              onClick={() => handlePageClick(pageNumber)}
              variant={currentPage === pageNumber ? "filled" : "outlined"}
              aria-label={`Go to page ${pageNumber}`}
              className={styles.pageButton}
            >
              {pageNumber}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
